import wNumb from "wnumb";
import { debounce, hasDiv } from '../utils/treatment';
import { handleSetMoreHeight } from '../functions/setHeights';

export default class Used{

  constructor(filters){
    this.pathname = new URL(window.location.href).pathname;
    this.filters = filters;

    this.initSliders();
    this.onLoadPage();
    this.initListeners();

    const filterUsed = document.querySelector('#form-filter-used');
    if(hasDiv(filterUsed)){
      $('#form-filter-used').on('change submit', event => {
        event.preventDefault();
        this.filterSearch(event.target.form);
        this.updateItemCount(document.querySelectorAll(`[name="${event.target.name}"]:checked`).length, event.target.name.replace('[]',''));
      });

      $('#used-order').on('change', () => {
        this.filterSearch(filterUsed);
      });

      $('#used-limit').on('change', () => {
        this.filterSearch(filterUsed);
      });
    }

  }

  // Some elements lose the listener after updating the partial, this function is to facilitate these elements to be re-inserted on the page.
  initListeners(){
    document.querySelectorAll('.page-link').forEach(item => {
      item.addEventListener('click', (event) => {
        const page = event.target.getAttribute('data-page');
        $('#pagination-used-input').val(page);
        this.filterSearch('#form-filter-used');
      });
    });
  }

  initSliders(){
    //range slider
    const filterSliders = document.querySelectorAll('.filter-range-slider') || [];
    Array.from(filterSliders).forEach((slider) => {
      if(slider != undefined) {
        let curPrefix = slider.dataset.prefix;
        let curSuffix = slider.dataset.suffix;
        let curStep = Number(slider.dataset.step);
        let curMinPrice = Number(slider.dataset.min);
        let curMaxPrice = Number(slider.dataset.max);

        const sliderFormat = wNumb({
          decimals: 0,
          thousand: '.',
          prefix: curPrefix,
          suffix: curSuffix
        });


        noUiSlider.create(slider, {
            connect: true,
            step: curStep,
            start: [curMinPrice, curMaxPrice],
            range: {
                'min': [curMinPrice],
                'max': [curMaxPrice]
            },
            format: sliderFormat,
        });

        const nodes = [
          slider.parentElement.querySelector('.min-value'),
          slider.parentElement.querySelector('.max-value')
        ];

        const inputs = [
          slider.parentElement.querySelector('input[name$=_min]'),
          slider.parentElement.querySelector('input[name$=_max]'),
        ];


        slider.noUiSlider.on('end', (values, handle) => {
          nodes[handle].innerHTML = values[handle];
          inputs[handle].value = values[handle].replace('R$ ', '').replace('.', '');

          debounce(this.filterSearch(),100);
        });
      }
    })
    //range slider
  }

  getCurrentUrl(path = ''){
    return new URL(window.location.origin + '/' + path );
  }

  filterSearch(formSelector = '#form-filter-used') {

    let limit = document.querySelector('#used-limit');
    let page = document.querySelector('#pagination-used-input');
    let order = document.querySelector('#used-order');

    limit = limit.value ? limit.value : 12;
    page = page ? page.value : 1;
    order = order ? order.value : '';

    let serializeForm = $(formSelector).serialize();

    serializeForm = serializeForm.replaceAll("%20","&search=")

    let url = this.getCurrentUrl('seminovos?' + serializeForm);
    url.searchParams.append('limit', limit);
    url.searchParams.append('page', page);
    url.searchParams.append('order', order);

    if(this.pathname !== '/seminovos'){
      window.location.href = url.href;
    } else {
      history.pushState(null,null,url.search);

      const filters =  this.unSerialize(url.href);
      $('#listCars').css('filter', 'blur(5px)');
      $.request('onGetFilterCars', {
        data: filters,
        loading: '.loader-wrapper',
        complete: () => {
          $('#listCars').css('filter', 'unset');
          this.initListeners();
          this.checkAll();

          handleSetMoreHeight('.js-used-title', 768);

          const observer = lozad(); // lazy loads elements with default selector as '.lozad'
          observer.observe();
        }
      });
    }
  }


  checkAll(){//not great, checks all models
    const els = document.querySelectorAll(".modelname");
    for (const el of els) {
      document.querySelector("[id='"+el.innerHTML+"']").checked = true;
      let models = document.querySelector("#collapse-models");

      if(!models.classList.contains("active"))
        models.classList.add('show');
    }
    this.updateItemCount(document.querySelectorAll(`[name="models[]"]:checked`).length,'models');
  }

  onLoadCheckbox(key, data){

    let items = [];
    if(data) {
      if(typeof(data) == 'string'){
        items = [data];
      } else {
        items = data;
      }

      let itemString = '';

      $(`input[name="${key}[]"]`).each(function () {
        itemString = $(this);
        items.forEach(function (item) {
          if(itemString.val() == item) {
            itemString.prop('checked', true);
          }
        });
      });
    }

    this.updateItemCount(items.length || 0, key);
  }

  onLoadCheckboxImage(key,data) {
    let items = [];
    if(data && data.length > 0) {
      if(typeof(data) == 'string'){
        items = [data];
      } else {
        items = data;
      }

      $(`input[name="${key}[]"]`).each(function () {
        let itemCategoryId = $(this).attr('id');
        let itemCategoryLabel = $(`label[for=${itemCategoryId}] > li` );
        let itemCategory = $(this);

        items.forEach(function (item, index) {
          if(itemCategory.val() == item) {
            itemCategory.prop('checked', true);
            itemCategoryLabel.addClass('checked');
          }
        });

      });
    } else {
      $(`input[name="${key}[]"]`).each(function () {
        let itemCategoryId = $(this).attr('id');
        $(this).prop('checked', false);
        $(`label[for=${itemCategoryId}] > li` ).removeClass('checked');
      });
    }

    this.updateItemCount(items.length, key);

  }

  internalSearch(key){
    const element = document.querySelector(`.list-${key}-wrapper .used-model-filter-internal-search`);

    if(hasDiv(element)){
      element.addEventListener('input', debounce(event =>{
        const value = event.target.textContent.trim();
        this.filterOptions(key, value);
      }), 500);
    } else {
      console.error('Internal search', `.list-${key}-wrapper .used-model-filter-internal-search not found`)
    }
  }

  filterOptions(key, value){
    $(`input[name="${key}[]"]`).each(function () {
      $(this).parent().show();
      if(value && !this.labels[0].textContent.toLowerCase().match(value.toLowerCase())) $(this).parent().hide()
    });
  }

  fillFilters(data){
    this.filters.forEach(filter => {
      switch (filter.type) {
        case 'checkbox':
          this.onLoadCheckbox(filter.key, data[filter.key]);
          if(filter.search){
            this.internalSearch(filter.key);
          }
          break;

        case 'checkbox-image':
          this.onLoadCheckboxImage(filter.key, data[filter.key]);
          break;

        case 'slider':
          const values = filter.slider_keys.map(key => {
            return {
              key,
              value: data[key]
            }
          });

          this.onLoadSlider(filter.key, values);
          break;

        case 'select':
        case 'text':
        default:
          this.onLoadValue(filter.key, data[filter.key])
          break;
      }
    });
  }

  onLoadPage() {
    let data = this.unSerialize(window.location.href);
    this.fillFilters(data);

    if($('[name="order"]').length > 0){
      $('[name="order"]').val(data.order);
    }

    if($('[name="limit"]').length > 0){
      $('[name="limit"]').val(data.limit);
    }

    let filterClicked  = document.querySelectorAll('.used-model-filter-expanded-list input[type="checkbox"]');
    if(hasDiv(filterClicked)){
        filterClicked.forEach((filter, i) => {
          filter.addEventListener('change', (event) => {

            // If exists image;
            const element = event.target.nextElementSibling.querySelector('li');
            if(hasDiv(element)){
              if(filter.checked == true){
                  element.classList.add('checked');
              } else {
                  element.classList.remove('checked');
              }
            }
          });
        });
    }
  }

  onLoadSlider(key, data){
    $(data[0].key).val(data[0].value);
    $(data[1].key).val(data[1].value);

    const slider = document.querySelector(`#filter-${key}-range`);
    if(hasDiv(slider)){
      slider.noUiSlider.set( [Number(data[0].value), Number(data[1].value)] );
    } else {
      console.error('on load slider', `#filter-${key}-slider not found`)
    }

  }

  onLoadValue(key, value){
    $(key).val(value);
  }


  // adiciona items filtrados
  updateItemCount(length, key) {
    if(typeof length == 'object' || Array.isArray(length) ){
      length = length.length
    }

    const $counter = document.querySelector(`#filter-label-${key} > .counter`);
    const $clear   = document.querySelector(`#heading-${key} > .clear`);;

    if(hasDiv($counter) && hasDiv($clear)){
      if(!length) {
        $counter.style.display = 'none';
        $clear.style.display = 'none';
      } else {
        $counter.style.display = '';
        $counter.innerHTML = `(${length})`;

        $clear.style.display = '';
        $clear.addEventListener('click', () => this.clear(key));
      }
    }
  }

  clear(key){
    const entries = document.querySelectorAll(`[name="${key}[]"]`);
    if(hasDiv(entries)){
      entries.forEach(entry => {
        if(!['button', 'submit', 'reset', 'hidden'].includes(entry.type)){
          //entry.value = '';
          entry.checked = false;
          entry.selected = false;
        }

        // Todo: checkbox-image
        if(key == 'categories'){
          this.onLoadCheckboxImage(key, []);
        }



        this.filterSearch();
      })
    }

    this.updateItemCount(0, key);
  }


  unSerialize(url) {
    let params = {};
    let parser = new URL(url);
    parser.href = url;
    let query = parser.search.substring(1);
    let vars = query.replaceAll('%5B%5D', '').split('&');
    if(vars.length > 1){
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');
        if(params.hasOwnProperty(pair[0])){
          if(typeof(params[pair[0]]) == 'string'){
            params[pair[0]] = [params[pair[0]], pair[1]];
          } else {
            params[pair[0]] = [...params[pair[0]], pair[1]];
          }
        } else {
          params[pair[0]] = decodeURIComponent(pair[1]);
        }
      }
    }
    // console.table(params);
    return params;
  }
}
